import isEmpty from 'lodash/isEmpty';
import { SearchResponseEvents } from '../../../../utils/transformation';

export const SEARCH_PROMOTED_RANK_EXPERIMENT_2 = {
    name: 'search_promoted_event_card_rank_2',
    param: 'group',
};

export enum SearchPromotedRankExperimentGroup {
    control = 'Rank1&2',
    rank1and3 = 'Rank1&3',
    rank1and4 = 'Rank1&4',
}

export function getSortedEvents(
    events: SearchResponseEvents['events'],
    promotedPositions: SearchPromotedRankExperimentGroup,
) {
    if (isEmpty(events.promoted)) {
        return events.organic;
    }

    switch (promotedPositions) {
        case SearchPromotedRankExperimentGroup.rank1and3:
            return interleavePromotedEvents(events, [1, 3]);
        case SearchPromotedRankExperimentGroup.rank1and4:
            return interleavePromotedEvents(events, [1, 4]);
        case SearchPromotedRankExperimentGroup.control:
        default:
            return [...events.promoted, ...events.organic];
    }
}

function interleavePromotedEvents(
    { promoted, organic }: SearchResponseEvents['events'],
    positions: number[],
) {
    let sortedEvents = [...organic];

    promoted.forEach((event, index) => {
        // If no position has been provided, just put the element in the end
        const newPromotedPosition =
            (positions[index] || sortedEvents.length) - 1;

        sortedEvents = interleaveIntoArray(
            sortedEvents,
            event,
            newPromotedPosition,
        );
    });

    return sortedEvents;
}

function interleaveIntoArray<T>(array: T[], element: T, position: number): T[] {
    const result = [...array];

    // If the desired position of A is greater than the current length of the array,
    // insert A at the end of the array.
    if (position > result.length) {
        position = result.length;
    }

    result.splice(position, 0, element);

    return result;
}
